import { getCookie } from 'cookies-next';

/**
 * O client_id que o Measurement Protocol do GA4 espera é só a parte final
 * do cookie _ga (ex: "_ga=GA1.2.123456789.987654321" -> "123456789.987654321")
 * — sem isto, o evento "purchase" disparado pelo backend não consegue
 * ligar-se à sessão que gerou a compra.
 */
export function getGa4ClientId(): string | null {
  const gaCookie = getCookie('_ga') as string | undefined;
  if (!gaCookie) return null;

  const parts = gaCookie.split('.');
  if (parts.length < 4) return null;

  return `${parts[2]}.${parts[3]}`;
}

// Stream GA4 do site — o cookie da sessão chama-se _ga_<id sem "G-">.
const GA4_MEASUREMENT_ID =
  process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID || 'G-M62PNLF1F4';

/**
 * Id da sessão GA4 atual, lido do cookie _ga_<ID>. Vai com a encomenda para
 * a compra enviada pelo servidor entrar nesta sessão (e manter a origem do
 * anúncio) mesmo que o pagamento só seja confirmado depois de ela expirar.
 *
 * A Google mudou o formato do cookie em 2025, por isso lê os dois:
 *   GS1.1.1746787364.1.1.1746787400.0.0.0   -> 1746787364
 *   GS2.1.s1746787364$o1$g1$t1746787400...  -> 1746787364
 */
export function getGa4SessionId(): string | null {
  const cookie = getCookie(
    `_ga_${GA4_MEASUREMENT_ID.replace(/^G-/, '')}`,
  ) as string | undefined;
  if (!cookie) return null;

  const part = cookie.split('.')[2];
  if (!part) return null;

  const sessionId = cookie.startsWith('GS2')
    ? part.split('$')[0].replace(/^s/, '')
    : part;

  return /^\d+$/.test(sessionId) ? sessionId : null;
}

export function getMetaFbp(): string | null {
  return (getCookie('_fbp') as string | undefined) ?? null;
}

export function getMetaFbc(): string | null {
  return (getCookie('_fbc') as string | undefined) ?? null;
}
